import React from 'react';
import { FaLinkedin } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-black py-10 text-center text-white">
      <div className="flex justify-center space-x-8 text-sm mb-4">
        <a href="#about" className="hover:underline">À propos</a>
        <a href="#services" className="hover:underline">Services</a>
        <a href="#contact" className="hover:underline">Contact</a>
      </div>

      <div className="mb-4">
        <a
          href="https://www.linkedin.com/company/amplifymycom/"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block text-white hover:text-blue-500"
        >
          <FaLinkedin size={24} />
        </a>
      </div>

      <p className="text-xs text-gray-400">AmplifyMyCom © 2025</p>
    </footer>
  );
};

export default Footer;
